import { createSlice } from '@reduxjs/toolkit';

export const answerSlice = createSlice({
  name: 'answers',
  initialState: {
    data: [],
  },
  reducers: {
    setAnswerList: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAnswerList } = answerSlice.actions;

export const selectAnswers = (state) => state.answers.data;

export default answerSlice.reducer;